export class PDFFeeAnalysisConfig {
  static readonly MaxFeeDetailsColumnToDisplayLogo = 8;
  static readonly ReduceFeeColumnHeight = 5;
  static readonly RowHeight = 35;
  static readonly FooterHeight = 40;
  static readonly LabelLineDetailHeight = 25;
  static readonly LabelLineProjectionHeight = 10;
  static readonly MarginHeight = 25;
  static readonly FeeDetailContentWidth = 450;
  static readonly FeeDetailContentWidthWithoutLogo = 475;
  static readonly MaxSubProductLegendPerRow = 5;
  static readonly DefaultFeeTitleHeight = 17;
}
